import { motion } from "framer-motion";
import { STEPS } from "@/data/site";

export const HowItWorks = () => {
  return (
    <section id="come-funziona" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl mb-16">
          <h4 className="text-xs uppercase tracking-[0.3em] text-gold-500 font-sans mb-5">
            Come funziona
          </h4>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-white leading-tight">
            Iniziare è più semplice
            <br />
            <span className="italic text-gray-400">di quanto pensi.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`step-${s.n}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="relative rounded-2xl border border-white/10 bg-ink-800 p-8"
            >
              <span className="font-serif text-6xl text-gold-500/25">{s.n}</span>
              <h3 className="mt-2 font-serif text-2xl text-white">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-gray-400">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
